export * from './NotaFiscalTab'
